/**
 * Created by vscode.
 * @DESC: 动态加载路由
 * @User: xiaoxiong
 * @Date: 2022/04/25
 * @Time: 14:30
 */
import Vue from 'vue'
import router, { resetRouter } from '@/router'
import { Toast } from 'vant'
import store from './store'
import { formatRoute } from '@/utils/index'
import axios from './utils/http'
Vue.use(Toast)

// 进入路由之前
router.beforeEach(async (to, from, next) => {
  let accessRoutes = [];
  // 获取后台配置的页面信息 动态生成路由
  let path = to.path
  if (path == '' || path == '/') {
    path = 'index'
  }
  const params = {
    'path': path
  }
  if (store.state.routes.length <= 0) {
    axios.get('https://adv.bugmake.com/api/web/index', {params: params}).then((res) => 
    {
      let code = res.code
      if (code != 1) {
        Toast('页面加载错误')
        return false
      } else {
        let data = res.data
        accessRoutes.push(formatRoute(data.enname, data.path))
        store.state.data = data
      }
    }).finally (() => {
      resetRouter() // 重置路由
      accessRoutes.forEach(function (itemRoute) {
        router.addRoute(itemRoute)  // 动态添加可访问路由
      })
      // 动态添加路由 需要在确认加入成功后跳转 使用下面的方法
      store.state.routes = accessRoutes
      next({ ...to, replace: true })
    })
  } else {
    next()
  }
})

// 进入路由之后
router.afterEach(() => {})
